import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M36.67 26.762a.762.762 0 1 1 0-1.524q3.15 0 6.299.51a3.05 3.05 0 0 1 2.443 2.175l.474 1.664q.026.09.045.18c.354 1.608-.694 3.19-2.286 3.622-1.53.415-3.259.73-4.64.883a.762.762 0 1 1-.168-1.515 31 31 0 0 0 4.41-.839c.831-.225 1.369-1.037 1.196-1.824l-.023-.09-.473-1.664a1.52 1.52 0 0 0-1.222-1.087 38 38 0 0 0-6.055-.49m-25.34.762q-3.027 0-6.055.491a1.52 1.52 0 0 0-1.222 1.087l-.473 1.664q-.013.045-.023.09c-.173.787.365 1.599 1.197 1.824 1.45.393 3.102.695 4.409.84a.762.762 0 0 1-.167 1.514 32.4 32.4 0 0 1-4.64-.883c-1.593-.432-2.64-2.014-2.287-3.622q.02-.09.045-.18l.474-1.664A3.05 3.05 0 0 1 5.03 26.51q3.151-.51 6.3-.51a.762.762 0 1 1 0 1.523m22.061-8.381a3.05 3.05 0 0 0 3.048 3.048 3.05 3.05 0 0 0 3.047-3.048 3.05 3.05 0 0 0-3.047-3.048 3.05 3.05 0 0 0-3.048 3.048m-1.524 0a4.574 4.574 0 0 1 4.572-4.571 4.574 4.574 0 0 1 4.571 4.571 4.574 4.574 0 0 1-4.571 4.572 4.574 4.574 0 0 1-4.572-4.572m-23.124.762a3.05 3.05 0 0 0 3.048 3.048 3.05 3.05 0 0 0 3.047-3.048 3.05 3.05 0 0 0-3.047-3.048 3.05 3.05 0 0 0-3.048 3.048m-1.524 0a4.574 4.574 0 0 1 4.572-4.572 4.574 4.574 0 0 1 4.571 4.572 4.574 4.574 0 0 1-4.571 4.572 4.574 4.574 0 0 1-4.572-4.572m16.764 16c4.356 0 7.517-.407 9.454-1.199a1.524 1.524 0 0 0 .918-1.708l-.592-2.97a3.81 3.81 0 0 0-3.414-3.05q-2.528-.216-6.366-.216t-6.367.216a3.81 3.81 0 0 0-3.413 3.05l-.592 2.97a1.524 1.524 0 0 0 .918 1.709c1.937.791 5.098 1.198 9.454 1.198m0 1.524c-4.537 0-7.871-.43-10.03-1.312a3.05 3.05 0 0 1-1.836-3.417l.592-2.97a5.33 5.33 0 0 1 4.778-4.27q2.6-.222 6.496-.222t6.495.221a5.33 5.33 0 0 1 4.779 4.271l.592 2.97a3.05 3.05 0 0 1-1.836 3.417c-2.16.883-5.493 1.312-10.03 1.312M19.41 16.095a4.575 4.575 0 0 0 4.572 4.572 4.575 4.575 0 0 0 4.571-4.572 4.575 4.575 0 0 0-4.571-4.571 4.575 4.575 0 0 0-4.572 4.571m-1.524 0A6.1 6.1 0 0 1 23.984 10a6.1 6.1 0 0 1 6.095 6.095 6.1 6.1 0 0 1-6.095 6.096 6.1 6.1 0 0 1-6.096-6.096",
      clipRule: "evenodd"
    }
  )
);
var SvgConferenceOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ConferenceOutlined_default = SvgConferenceOutlined;

export { ConferenceOutlined_default as default };
